import { makeStyles, createStyles } from '../../styles';
export default makeStyles((_) => createStyles({
    root: {
        width: '100%',
    },
}));
//# sourceMappingURL=SelectField.styles.js.map